import { WORKSPACE_LOADER_MIN_MS, markWorkspaceLoaderStarted } from '../../components/loading/workspace/useMinimumVisibleLoading';
import {
  clearImpersonationExiting,
  markImpersonationExiting,
} from '../utils/impersonationSession';

export const IMPERSONATION_RETURN_PARAM = 'impersonationReturn';
export const IMPERSONATION_EXIT_MIN_MS = WORKSPACE_LOADER_MIN_MS;
const IMPERSONATION_LOADER_STARTED_KEY = 'impersonation_loader_started_at';

export const IMPERSONATION_ENTER_STAGES = [
  { at: 0, message: 'Authenticating…' },
  { at: 800, message: 'Signing into this account…' },
  { at: 1800, message: 'Preparing workspace…' },
];

export const IMPERSONATION_EXIT_STAGES = [
  { at: 0, message: 'Signing out of this account…' },
  { at: 800, message: 'Returning to admin panel…' },
  { at: 1800, message: 'Preparing admin workspace…' },
];

export function markImpersonationLoaderStarted() {
  const startedAt = Date.now();
  if (typeof window === 'undefined') return startedAt;
  try {
    sessionStorage.setItem(IMPERSONATION_LOADER_STARTED_KEY, String(startedAt));
  } catch {
    // ignore
  }
  markWorkspaceLoaderStarted();
  return startedAt;
}

export function getImpersonationLoaderRemaining(minMs = IMPERSONATION_EXIT_MIN_MS) {
  if (typeof window === 'undefined') return minMs;
  try {
    const startedAt = Number(sessionStorage.getItem(IMPERSONATION_LOADER_STARTED_KEY));
    if (!Number.isFinite(startedAt) || startedAt <= 0) return minMs;
    return Math.max(0, minMs - (Date.now() - startedAt));
  } catch {
    return minMs;
  }
}

export function clearImpersonationLoaderStarted() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(IMPERSONATION_LOADER_STARTED_KEY);
  } catch {
    // ignore
  }
}

export function waitForImpersonationExitMin(startedAt, minMs = IMPERSONATION_EXIT_MIN_MS) {
  const elapsed = Date.now() - startedAt;
  const remaining = minMs - elapsed;
  if (remaining <= 0) return Promise.resolve();
  return new Promise((resolve) => window.setTimeout(resolve, remaining));
}

export function withImpersonationReturnParam(href, startedAt = Date.now()) {
  const url = new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
  url.searchParams.set(IMPERSONATION_RETURN_PARAM, String(startedAt));
  return url.toString();
}

export function consumeImpersonationReturn() {
  if (typeof window === 'undefined') {
    return { active: false, startedAt: null };
  }

  const url = new URL(window.location.href);
  const raw = url.searchParams.get(IMPERSONATION_RETURN_PARAM);
  if (raw != null) {
    url.searchParams.delete(IMPERSONATION_RETURN_PARAM);
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
    markImpersonationExiting();
    const startedAt = Number(raw);
    return {
      active: true,
      startedAt: Number.isFinite(startedAt) && startedAt > 0 ? startedAt : Date.now(),
    };
  }

  return { active: false, startedAt: null };
}

export { clearImpersonationExiting };
